import React, {Component} from "react";

// import HyperDatepicker from "../../components/Datepicker";
// import Spinner from "../../components/Spinner";
// import {WaitingOrNodataMessage} from "../../components/waiting-or-nodata-message";
// import {Paginator} from "../../components/Paginator";
import {getLastElementOr, onlyNotNull, showlog, beautify, isNotEmptyArray} from "../../utils";
import 'mapbox-gl/dist/mapbox-gl.css';

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl';

import {debounceTime, distinct, fromEvent, map} from 'rxjs';
import { sha256 } from 'js-sha256';

import {CALENDAR_DATE_FORMAT_IT, DATE_FORMAT_IT, DATETIME_FORMAT_IT} from "../../conf";
import {getLastVersion, searchMagnitudeOrders, searchOrders} from "./orders";
import {geoCodeAddress, setGeoCodeAddress} from "../../business-logic";

import '../../style/order.css';
import './orders.css';
import {WaitingOverPageComponent} from "../../components/WaitingOverComponent/waiting-over-component";

import moment from 'moment';
import '../../style/validity-setting-pannel-style.css';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import {AlertPanel} from "../../components/alert/alert-panel";
import {saveAs} from 'file-saver';


const orderFieldMap = {
	id: "id",
	// _id: "dbID",
	numDocOriginale: "Documento",
	// operatorId: "opID",
	companyName: "Azienda",
	operatorUsername: "Agente",
	group: "Gruppo",
	// operatorSyncUrl: "syncURL",
	customer: "Cliente",
	itemsMagnitude: "Articoli",
	// deliveryDate: "Consegna",
	device: "Device",
	appVersion: "App Version",
	applicablePromotion: "Promozione",
	moment: 'Data'
};

const articleFieldMap = {
	codice: "Codice",
	name: "Articolo",
	// "DesEstesa": "Descrizione",
	"prezzo": "Prezzo",
	"startPrice": "Prezzo di partenza",
	"qt": "Qt",
	// "listino": "Listino"
};


mapboxgl.accessToken = process.env.REACT_APP_MAP_BOX_TOKEN;
let MAP = null;
let popup = null;


export class OrdersPage extends Component<any, any> {


	state = {
		orders: [],
		inWaiting: false,
		activeTab: null,
		coords: null,
		search: {
			search: "",
			// from: moment( "09/09/2019", DATE_FORMAT_IT).unix(),
			from: moment().add(-2, "days").unix() * 1000,
			// to: moment().add(1, "days").unix() * 1000,
			to: moment().unix() * 1000,
			page: 1
		},
		rawOrderPopup: null,
		lng: 12.45,
		lat: 37.8,
		zoom: 14,
		articlesImages: [],
		magnitude: 0,
		companyImagesLoaded: [],
		// currentPage: 1
		lastVersion: null,
		openPannels: [],
		errorPannel: undefined,
		openArticlePannels: []
	}

	constructor(props) {
		super(props);


		this.setSearch = this.setSearch.bind(this);

	}

	setSearch = () => {

		return (
			new Promise<any>((onEnd, onFail) => {
				showlog("Alla ricerca", this.state.search.search);

				let markers = document.getElementsByClassName("marker");
				while (!!markers && (markers.length > 0)) {
					for (let marker of markers) {
						if (!!marker && !!marker.parentNode) {
							marker.parentNode.removeChild(marker);
						}
					}
				}

				Promise.resolve()
					.then(() => {
						if (this.state.magnitude === 0) {
							return (
								searchMagnitudeOrders(this.state.search)
									.then(magnitude => {
										showlog("order magnitude: ", magnitude)
										return magnitude
									})
									.catch(e => {
										showlog("errore alla magnitude");
										showlog(e);
										onFail(e);
									})
							)
						} else return this.state.magnitude
					})
					.then(magnitude => {
						searchOrders(this.state.search)
							.then(result => {
								showlog("ritorno dalla ricerca");
								showlog(result);


								Promise.all(
									result

										.filter(data => (!!data.payload && !!data.payload.deliveryAddress))
										// .filter(data => !!data.payload.indirizzi[data.payload.indirizzoDefault])
										.map(data => {
											// let adr = data.payload.indirizzi[data.payload.indirizzoDefault];
											let adr = data.payload.deliveryAddress;
											// return `${adr.via}%20${adr.cap}%20${adr.citta || adr.comune}%20${adr.province || adr.sigla_provincia}%20${adr.regione}`;
											return `${adr.via}%20${adr.cap}%20${adr.citta || adr.comune}`;
											// `${data.payload.indirizzi[data.payload.indirizzo_default].via}%20${data.payload.indirizzi[data.payload.indirizzo_default].cap}%20${data.payload.indirizzi[data.payload.indirizzo_default].citta}`
										})

										// .map( data => data.payload.customer.address ) // da cambiare con i componenti
										.map((address, aIndex) => {
											// showlog("chiamata NOSTRA");
											return (

												geoCodeAddress(address)
													.then((coordPoint: number[]) => {

														// showlog("ritorno dalla NOSTRA chiamata di reverse geocoding");
														// showlog( coordPoint );
														// debugger;

														if (!coordPoint || !(coordPoint[0] && coordPoint[1])) {

															showlog("%cchiamata MapBox per geocoding di "+ address, "color: #f00;");

															return (
																fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${address}.json?access_token=${process.env.REACT_APP_MAP_BOX_TOKEN}`)
																	.then(response => response.json())
																	.then(response => {

																		showlog("%cRESPONSE MapBox per geocoding di "+ address, "background: #f00; color: #FFF;");
																		showlog(result); // tutti gli ordini
																		showlog(result.filter(data => (!!data.payload && !!data.payload.deliveryAddress))[aIndex]); // ordine corrispondente
																		showlog(response); // risposta geocoding


																		// let resultOrder = result.filter(data => (!!data.payload && !!data.payload.indirizzi))[aIndex]
																		let resultOrder = result.filter(data => (!!data.payload && !!data.payload.deliveryAddress))[aIndex];

																		// showlog("result order");
																		// showlog(resultOrder);
																		// debugger;

																		let preData =
																			response.features
																				.filter(f => (
																					(f.place_type[0] === "address")
																					// && (!!resultOrder.payload.indirizzi)
																					&& !!resultOrder.payload.deliveryAddress
																					&& (f.place_name.indexOf(resultOrder.payload.deliveryAddress.comune) !== -1)
																				))
																				.reduce( getLastElementOr, null )
																		;


																		// showlog("predata");
																		// showlog( preData );
																		// showlog("response");
																		// showlog(response);
																		// showlog("resultOrder");
																		// showlog(resultOrder);
																		// debugger;

																		// if( !preData ) return response;
																		if (!preData) {
																			preData = {
																				geometry: {
																					coordinates: [1, 1]
																				}
																			}
																		}

																		return (
																			setGeoCodeAddress(address, preData.geometry.coordinates[0], preData.geometry.coordinates[1])
																				.then(storeResult => {
																					// showlog("address salvato");
																					// showlog( storeResult );
																					return response;
																				})
																				.catch(e => {
																					showlog("errore");
																					showlog(e);
																					return Promise.reject(e);
																				})
																		);

																	})
																	.then(response => ({
																		order: result.filter(data => (!!data.payload && !!data.payload.indirizzi))[aIndex],
																		coordsListData: response
																	}))
																	.catch(e => Promise.reject(e))
															)

														} else {
															return ({
																order: result.filter(data => (!!data.payload && !!data.payload.indirizzi))[aIndex],
																coordsListData: {
																	features: [{
																		place_type: ["address"],
																		place_name: address,
																		geometry: {
																			coordinates: coordPoint
																		}
																	}]
																}
															})
														}
													})
													.catch(e => {
														// MAI
														showlog("ERRORE");
														showlog(e);
													})


											);
										})
								)
									.then((list) => {
										showlog("lista coords");
										showlog(list);

										showlog('lista ritorno filtrata', result.filter(data => (!!data.payload && !!data.payload.deliveryAddress)))


										let bottomLeftCorner = [180, 90];
										let topRightCorner = [0, 0];
										let reCenter = [0, 0];
										let coords =
											list
												.map((coordData, cdIndex) => {

													if (!coordData) {
														coordData = {coordsListData: {features: []}}
													}
													if (
														!coordData ||
														!coordData.coordsListData
													) {
														coordData.coordsListData = {features: []}
													}
													if (
														!coordData ||
														!coordData.coordsListData ||
														!coordData.coordsListData.features
													) {
														coordData = {coordsListData: {features: []}}
													}

													return ({
														coordsData:
															coordData.coordsListData.features
																.filter(f => (
																	(f.place_type[0] === "address")
																	// && (f.place_name.indexOf( coordData.order.payload.indirizzi[coordData.order.payload.indirizzo_default].via ) !== -1)
																	// && (!!coordData.order.payload.indirizzi)
																	// && (f.place_name.indexOf(coordData.order.payload.indirizzi[coordData.order.payload.indirizzo_default]?.citta) !== -1)
																))
																// .reduce(getLastElementOr, null),
																[0] || null,
														ord: result.filter(data => (!!data.payload && !!data.payload.deliveryAddress))[cdIndex]
													})
												})

												.map(({coordsData, ord}, cIndex) => {


													// showlog("coordData");
													// showlog(coordsData);
													// debugger;

													if (!coordsData || (coordsData === null) || (coordsData.geometry.coordinates.length < 2)) return null;

													return ({
														order: ord,
														lng: coordsData.geometry.coordinates[0],
														lat: coordsData.geometry.coordinates[1]
													})
												})
												.map((coord, cIndex) => {

													if (!coord || (coord === null)) return null;
													if ((coord.lng === 1) && (coord.lat === 1)) return null;

													let el = document.createElement('div');
													el.className = !!coord.order.closed ? 'marker' : 'marker-blue';

													if (!!coord.order.closed) {

														if (!!coord.order.trashed) {
															el.innerHTML = `
                                                        <svg
                                                            height="250"
                                                            width="250"
                                                            viewBox={"0 0 20 20"}
                                                        >
                                                            <path
                                                                fill="#dcdcdc88"
                                                                d="M5.50183983,10.4944805 L5.50367966,10.4963203 L12.8482451,3.15175489 C13.5762779,4.25592793 14,5.57848014 14,7 C14,10.866 10.866,14 7,14 C3.134,14 0,10.866 0,7 C0,3.134 3.134,0 7,0 C8.67832535,0 10.218695,0.590646458 11.4245848,1.57541523 L11.4245848,1.57541523 L5.50183983,7.49816017 L3.50183983,5.49816017 L2.00183983,6.99816017 L5.5,10.4963203 L5.50183983,10.4944805 Z"
                                                            />
                                                        </svg>
                                                    `
															/* icona x
															el.innerHTML = `
																<svg
																	strokeMiterlimit="10"
																	style="fill-rule:nonzero;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;"
																	viewBox={"0 0 50 50"}
																	width="50"
																	height="50"
																>
																	<path d="M10 10L40 40L10 10Z" fill="none" opacity="1" stroke="#dcdcdc88" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
																	<path d="M10 40L40 10" fill="none" opacity="1" stroke="#dcdcdc88" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
																</svg>
															`;
															 */
														} else {
															el.innerHTML = `
                                                        <svg
                                                            height="250"
                                                            width="250"
                                                            viewBox={"0 0 20 20"}
                                                        >
                                                            <path
                                                                fill=${(!!this.state.lastVersion && (this.state.lastVersion === coord.order.appVersion)) ? "#00C752" : "#F8AA"}
                                                                d="M5.50183983,10.4944805 L5.50367966,10.4963203 L12.8482451,3.15175489 C13.5762779,4.25592793 14,5.57848014 14,7 C14,10.866 10.866,14 7,14 C3.134,14 0,10.866 0,7 C0,3.134 3.134,0 7,0 C8.67832535,0 10.218695,0.590646458 11.4245848,1.57541523 L11.4245848,1.57541523 L5.50183983,7.49816017 L3.50183983,5.49816017 L2.00183983,6.99816017 L5.5,10.4963203 L5.50183983,10.4944805 Z"
                                                            />
                                                        </svg>
                                                    `;
														}
													}

													let marker = new mapboxgl.Marker(el).setLngLat([coord.lng, coord.lat]).addTo(MAP);

													let totNettoMerci = coord.order.payload.items.reduce((totale, data) => {
														let qt = data.qt;
														totale += parseFloat(data.details.prezzoNettoSconti) * qt;
														return totale;
													}, 0);

													let totImponibile: number | string = parseFloat(totNettoMerci);
													totImponibile -= (totImponibile * parseFloat(coord.order.paymentPercSconto || 0) / 100);

													let qtTot = 0;
													coord.order.payload.items
														.forEach(art => {
															qtTot += parseFloat(art.qt)
														})
													;

													let totOmaggi = coord.order.payload.items.reduce((totale, data) => {
														return totale + parseFloat(data.details.omaggio);
													}, 0);
													let totScontoMerce = coord.order.payload.items.reduce((totale, data) => {
														return totale + parseFloat(data.details.scontoMerce);
													}, 0);


													totNettoMerci = parseFloat(totNettoMerci).toFixed(2);
													totImponibile = parseFloat('' + totImponibile).toFixed(2);

													let popup = new mapboxgl.Popup({
															offset: [0, -10],
															closeButton: false,
															closeOnClick: true
														})
															.setHTML(`
                                                    <div class="main-tooltip-popup">
                                                        <div class="main-tooltip-popup-row tooltip-order-customer">
                                                            <span>${coord.order.customer}</span>
                                                        </div>
                                                        <div class="main-tooltip-popup-row">
                                                            <div class="main-tooltip-popup-cell">Imponibile</div>
                                                            <div class="main-tooltip-popup-cell important-text">${totImponibile} €</div>
                                                        </div>
                                                        <div class="main-tooltip-popup-row">
                                                            <div class="main-tooltip-popup-cell">Quantità</div>
                                                            <div class="main-tooltip-popup-cell evident-color" style="display: block;">${qtTot} di <span class="evident-color">${coord.order.itemsMagnitude}</span> articoli</div>
                                                        </div>
                                                        <div class="main-tooltip-popup-row">
                                                            <div class="main-tooltip-popup-cell">Data</div>
                                                            <div class="main-tooltip-popup-cell">${!!coord.order.payload ? moment.unix(parseInt(coord.order.payload.startOrderTime, 10) / 1000).format(DATETIME_FORMAT_IT) : "-"}</div>
                                                        </div>
                                                        <div class="main-tooltip-popup-row">
                                                            <div class="main-tooltip-popup-cell">Consegna</div>
                                                            <div class="main-tooltip-popup-cell">${coord.order.moment}</div>
                                                        </div>
                                                        <div class="main-tooltip-popup-row">
                                                            <div class="main-tooltip-popup-cell">Agente</div>
                                                            <div class="main-tooltip-popup-cell">${coord.order.operatorUsername}</div>
                                                        </div>
                                                        <div class="main-tooltip-popup-row">
                                                            <div class="main-tooltip-popup-cell">Azienda</div>
                                                            <div class="main-tooltip-popup-cell">${!!coord.order.company ? coord.order.company.name : ""}</div>
                                                        </div>
                                                        <div class="main-tooltip-popup-row">
                                                            <div class="main-tooltip-popup-cell">Device</div>
                                                            <div class="main-tooltip-popup-cell">${coord.order.device}</div>
                                                        </div>
                                                        <div class="main-tooltip-popup-row">
                                                            <div class="main-tooltip-popup-cell">Versione App</div>
                                                            <div class="main-tooltip-popup-cell dark-text">${coord.order.appVersion}</div>
                                                        </div>
                                                    </div>
                                                `)
													;
													const element = marker.getElement();

													// element.addEventListener('mouseenter', () => {
													element.addEventListener('click', () => {
														showlog("hover dell'ordine");
														showlog(coord.order);
														showlog([coord.lng, coord.lat]);
														// showlog( marker );

														popup.addTo(MAP);
													});
													element.addEventListener('mouseleave', () => popup.remove());

													marker.setPopup(popup);

													return coord;
												})
												.map((coord, coordIndex) => {

													if (!coord || (coord === null)) return null;

													if (
														(bottomLeftCorner[0] === 180) ||
														(
															(Math.abs(coord.lng - bottomLeftCorner[0]) < 10) &&
															(Math.abs(coord.lng - topRightCorner[0]) < 10) &&
															(Math.abs(coord.lat - bottomLeftCorner[1]) < 10) &&
															(Math.abs(coord.lat - topRightCorner[1]) < 10)
														)
													) {
														if (bottomLeftCorner[0] > coord.lng) bottomLeftCorner[0] = coord.lng;
														if (bottomLeftCorner[1] > coord.lat) bottomLeftCorner[1] = coord.lat;
														if (topRightCorner[0] < coord.lng) topRightCorner[0] = coord.lng;
														if (topRightCorner[1] < coord.lat) topRightCorner[1] = coord.lat;
													}

													return coord;
												})
												.filter(onlyNotNull)
										;
										reCenter = [
											(topRightCorner[0] + bottomLeftCorner[0]) / 2,
											(topRightCorner[1] + bottomLeftCorner[1]) / 2
										];

										showlog("final calculation");
										showlog(coords);
										showlog(bottomLeftCorner);
										showlog(topRightCorner);
										showlog("center", reCenter);
										showlog("zoom: " + (15 - Math.floor(Math.abs(topRightCorner[0] - bottomLeftCorner[0]))));
										// debugger;


										this.setState({
												...this.state,
												coords: coords,
												orders: result || [],
												magnitude: magnitude,
												search: {
													...this.state.search,
													page: 1
												},
												// offset: 0,
												inWaiting: false
											},
											() => {

												if (!!MAP /*&& (typeof MAP.flyTo === 'function' )*/) {
													// @ts-ignore
													MAP.flyTo({
														center: reCenter,
														zoom: (15 - Math.floor(Math.abs(topRightCorner[0] - bottomLeftCorner[0])))
													});
													onEnd(undefined);
												} else {
													onEnd(undefined);
												}
											}
										)


									})
									.catch(e => {
										showlog("geocodong");
										showlog(e);

										this.setState({
												...this.state,
												inWaiting: false
											},
											() => {
												onFail(e);
											}
										);


									})

							})
							.catch(e => {
								showlog("errore");
								showlog(e);
								onFail(e);
							})
					})


				;
			})
		);


	}


	articleRenderer = (aIndex: number, oIndex: number) => {
		let article: any =
			this.state.orders
				.filter((o: any, oi: number) => oi === oIndex)
				.reduce(getLastElementOr, {payload: {items: []}})
				.payload.items
				.filter((it: any, itIndex: number) => itIndex === aIndex)
				.reduce(getLastElementOr, null)
		;



		// debugger;

		/*
		let applicablePromotionsArticles = null;
		if( !!order.articlesWithApplicablePromotion ) {
			applicablePromotionsArticles =
				order.articlesWithApplicablePromotion
					.filter( a => a.articleID == item.CodArt )
			// .reduce( getLastElementOr, null )
			;
		}


		let discountPolicy = null;
		if( !!order.discountPolicy ) {
			discountPolicy =
				order.discountPolicy

			;
		}
		*/


		// getImageData
		/*
		if(
			(
				!this.state.articlesImages ||
				(
					!this.state.articlesImages
						.filter( ai => ai.id === `img-${ order.companyName }-${ item.codice }` )
						.reduce( getLastElementOr, null )
				)
			) // && !this.state.companyImagesLoaded.filter( ic => ic === order.companyName ).reduce( getLastElementOr, null )
		) {

			fetch( `https://portaleagenti.caninosrl.it/mobileagent/company/${order.companyName}/article/img/${sha256(order.agent.syncUrl + item.codice)}` )
				.then( response => response.text() )
				.then( response => {
					showlog("response image");
					showlog(response);
					showlog(order);
					showlog(item);
					this.setState({
							...this.state,
							articlesImages: [
								...this.state.articlesImages,
								{
									id: `img-${ order.companyName }-${ item.codice }`,
									content: response
								}
							],
							companyImagesLoaded: [
								...this.state.companyImagesLoaded.filter( ic => ic !== order.companyName),
								order.companyName
							]
						},
						() => {
							// showlog("stato aggiornato");
							// showlog( this.state );
							// showlog(
							//     this.state.articlesImages
							//         .filter( ai => ai.id === [`img-${ order.companyName }-${ item.codice }`] )
							//         .reduce( getLastElementOr, null )
							// );
							// showlog(
							//     !this.state.articlesImages
							//         .filter( ai => ai.id === [`img-${ order.companyName }-${ item.codice }`] )
							//         .reduce( getLastElementOr, null )
							// );
							// debugger;
						}
					)
				})
				.catch(e => {
					showlog("errore al fetch");
					showlog( e );
					// debugger;

					if( !this.state.companyImagesLoaded.filter( ic => ic === order.companyName ).reduce( getLastElementOr, null ) ) {

						retrieveImages(order.agent.token, order.agent.group, order.agent.syncUrl, order.companyName)
							.then( () => {
								this.setState({
									...this.state,
									nounce: (new Date()).getTime(),
									companyImagesLoaded: [
										...this.state.companyImagesLoaded.filter( ic => ic !== order.companyName),
										order.companyName
									]
								})
							})
							.catch(e => {
								showlog("errore");
								showlog( e );
								// debugger;
							})
						;

					}

				})
			;
		}
		*/


		return (
			<div className={"article-expanded-area"}>
				<div className={"article-info-container"}>

					{/*
						TODO
						immagine
					*/}

					<div>
						<h5 className={"article-name"}><strong>{article.codice}</strong> {article.articolo}</h5>
						<div className={"article-prices"}>
							{
								(article.prezzo == article.startPrice)
									? null
									: <div className={"article-start-price"}>{article.startPrice} €</div>
							}
							<div className={"article-price"}>{article.prezzo} €</div>
							<div className={"article-qt"}>{article.qt} {article.measureUnit}</div>
						</div>

					</div>
					<div className={"article-details-container"}>
						{
							Object.keys(article.details)
								.map(field => (
									<div><label>{field}</label><span>{article[field] || "0"}</span></div>
								))
						}
					</div>
					<div className={"article-details-container"}>
						<div><label>disponibilita</label><span>{article.disponibilita || "0"}</span></div>
						<div>
							<label>listino</label>
							<span>
								{
									(!!article.listino && !!article.listino.desListino)
										? (article.listino.desListino +' ['+ article.listino.idListino +']')
										: ''
								}
							</span>
						</div>
						<div><label>listino cliente</label><span>{article.listinoCliente}</span></div>
						<div><label>listino prioritario</label><span>{article.listinoPrioritario}</span></div>
						<div><label>listino ordinario</label><span>{article.listinoOrdinario}</span></div>
						{/*<div><label>unità di misura</label><span>{article.measureUnit}</span></div>*/}
						<div><label>con IVA</label><span>{article.vatIncluded}</span></div>
						{/*
							TODO
							marca, famiglia, ecc...
						*/}
					</div>
					{/*
						TODO
						Promozioni
					*/}
				</div>
				<div className={"article-des-estesa"}>{article.DesEstesa}</div>

			</div>

		);

	}


	renderer = (oIndex: number) => {


		let order: any = this.state.orders[oIndex];
		let totNettoMerci;
		let totImponibile;
		let totOmaggi;
		let totScontoMerce;
		let qtTot = 0;

// debugger;

		try {


// showlog( !order.payload );
// showlog( !order.payload.items );
// showlog( order.payload.items.length );
// showlog( ( !order.payload || !order.payload.items || ( order.payload.items.length === 0 ) ) );
// if( !order.payload || !order.payload.items || ( order.payload.items.length === 0 ) ) return null;


// cleaning
			let fieldToCheck = ["type", "key", "ref", "props", "_owner"];
			order.payload.items
				.map(it => {
					Object.keys(it)
						.map(itField => {
							if (!!it[itField]) {
								if (
									Object.keys(it[itField])
										.filter(field => fieldToCheck.includes(field))
										.length === fieldToCheck.length
								) {
									delete it[itField];
								}
							}
						})
					;
					return it;
				})
			;


			totNettoMerci = order.payload.items.reduce((totale, data) => {
				let qt = data.qt;
				totale += parseFloat(data.details.prezzoNettoSconti) * qt;
				return totale;
			}, 0);

			totImponibile = parseFloat(totNettoMerci);
			totImponibile -= (totImponibile * parseFloat(order.paymentPercSconto || 0) / 100);


			order.payload.items
				.forEach(art => {
					qtTot += parseFloat(art.qt)
				})
			;

			totOmaggi = order.payload.items.reduce((totale, data) => {
				return totale + parseFloat(data.details.omaggio);
			}, 0);
			totScontoMerce = order.payload.items.reduce((totale, data) => {
				return totale + parseFloat(data.details.scontoMerce);
			}, 0);


			totNettoMerci = parseFloat(totNettoMerci).toFixed(2);
			totImponibile = parseFloat(totImponibile).toFixed(2);


// debugger;

		} catch (e) {
			showlog("errore");
			showlog(e);
			debugger;

		}


		return (
			<div className={"order-page-row-content"}>

				<h4
					onClick={clickEvent => {
						let file = new Blob([JSON.stringify(order)], {type: "text/json;charset=utf-8"});
// URL.createObjectURL(file);
						saveAs(file, `Ordine ${order.dbID || order._id}.json`);
					}}
				>
					DB ID: {order.dbID || order._id}
					<img
						src={'/imgs/save.png'}
						className={"download-order"}
					/>
					<img
						src={'/imgs/info.png'}
						className={"download-order"}
						onClick={clickEvent => {
							clickEvent.preventDefault();
							clickEvent.stopPropagation();
							this.setState({
								...this.state,
								rawOrderPopup: order
							});
						}}
					/>
				</h4>


				<div className={"order-page-customer-order"}> {/* ---- sezione cliente/ordine ---- */}
					<div className={"order-page-order"}>
						<div><label>ID</label><span>{order.id}</span></div>
						<div><label>Documento</label><span
							className={"light-color bold-text"}>{order.payload.NumDocOriginale || order.payload.docId || order.payload.NumeroDocumentoOriginale || ""}</span>
						</div>
						<div><label>Data
							Ordine</label><span>{!!order.payload ? moment.unix(parseInt(order.payload.startOrderTime, 10) / 1000).format(DATETIME_FORMAT_IT) : "-"}</span>
						</div>
						<div><label>Data</label><span>{order.moment}</span></div>
						<div className={""}><label>Netto</label><span>{totNettoMerci} €</span></div>
						<div className={"netto"}><label>Imponibile</label><span>{totImponibile} €</span></div>
						<div><label>IVA</label><span>{"TODO"}</span></div>
						<div><label>Addebiti</label><span>{"TODO"}</span></div>
						<div><label>Omaggi</label><span>{totOmaggi}</span></div>
						<div><label>Sconto Merce</label><span>{totScontoMerce} %</span></div>
						<div><label>Numero Articoli</label><span>{order.itemsMagnitude}</span></div>
						<div className={"netto"}><label>Totale Qt</label><span>{qtTot}</span></div>
						<div><label>Totale</label><span>{"TODO"}</span></div>

						<div><label>Condizione di
							pagamento</label><span>{(!!order.payload && !!order.payload.paymentCondition) ? (order.payload.paymentCondition.CodCondizPagamento + " " + order.payload.paymentCondition.PercSconto + "% " + order.payload.paymentCondition.Des) : "-"}</span>
						</div>
						<div><label>Status</label><span>{!!order.payload ? order.payload.status : "-"}</span></div>

						<div><label>Agente</label>
							<span>{order.operatorId + " " + order.operatorUsername + " " + order.operatorSyncUrl}</span>
						</div>
						<div><label>Dispositivo</label> <span>{order.device}</span></div>

						<div
							className={"order-note"}>{(!!order.payload && !!order.payload.customer && !!order.payload.customer.note) ? order.payload.customer.note : "Note: nessuna"}</div>
					</div>

					<div className={"order-page-customer"}>
						<div>
							{/*
						<img
							src={
								window.location.href
									.split("/")
									.filter((_, i) => i < 3)
									.join("/")
								+ APPS[0].logo
							}
							className={"no-company-picture"}
						/>
						*/}
							<div>
								<div
									className={"order-customer-name " + (
										(!!order.payload && !!order.payload.TipoAnagrafica && (order.payload.TipoAnagrafica == 6))
											? "potential-customer"
											: ""
									)
									}
								>
									<strong>{(!!order.payload && !!order.payload.customer) ? order.payload.anagrafica_id : "-"}, {order.customer}</strong>
								</div>

								<div><strong>Indirizzo di consegna</strong>
									{
										(!!order.payload && !!order.payload.deliveryAddress)
											? (order.payload.deliveryAddress.via + ", " + order.payload.deliveryAddress.comune + ", " + order.payload.deliveryAddress.cap )
											: "-"
									}
								</div>

								<div></div>
								<div><strong>PEC</strong>{!!order.payload ? order.payload.PEC : "-"}</div>
								<div><strong>SDI</strong>{!!order.payload ? order.payload.SDI : "-"}</div>
								<div><strong>annotations</strong>{"TODO"}</div>
								<div><strong>categoria</strong>{!!order.payload ? order.payload.categoria_name : "-"}
								</div>
								<div><strong>categoria
									sconti</strong>{!!order.payload ? order.payload.categoria_sconti : "-"}</div>
								<div><strong>codice
									fiscale</strong>{!!order.payload ? order.payload.codice_fiscale : "-"}</div>
								<div><strong>commercialCondition</strong>{"TODO"}</div>
								<div><strong>condizioni commerciali
									multiple</strong>{!!order.payload ? (!!order.payload.cond_com_per_indirizzo ? "true" : "false") : "-"}
								</div>
								<div><strong>email</strong>{!!order.payload ? order.payload.email : "-"}</div>
								<div><strong>piva</strong>{!!order.payload ? order.payload.piva : "-"}</div>
								<div><strong>telefono</strong>{!!order.payload ? order.payload.telefono : "-"}</div>
								<div><strong>tipologia
									commerciale</strong>{!!order.payload ? order.payload.tipologia_commerciale : "-"}
								</div>
								<div><strong>ultimo
									progressivo</strong>{!!order.payload ? order.payload.ultimoProgressivo : "-"}</div>
								<div><strong>sito web</strong>{!!order.payload ? order.payload.web_site : "-"}</div>
								<div><strong>zona</strong>{!!order.payload ? order.payload.zona : "-"}</div>

								<div></div>

								<div><strong>Data di Consegna</strong> {order.deliveryDate}</div>
								<div><strong>Sconto Pagamento</strong>{order.paymentPercSconto}</div>

								<div><strong>Fido</strong> {"TODO"}</div>
								<div><strong>Scadenze</strong> {"TODO"}</div>
							</div>
						</div>

					</div>

				</div>

				<div className={"order-page-info"}>
					<div><label>Ultima Sync</label><span>{order.lastSync}</span></div>
					<div><label>Indirizzo IP</label><span>{order.ipv4 || "0.0.0.0"}</span></div>
				</div>

				{/*
					<pre className={"log-content"}>
						{
							beautify( order.customer )
						}
					</pre>
					*/}


				{
					(!!order.payload && !!order.payload.items)
						? (
							<React.Fragment>
								<code>ARTICOLI</code><br/>


								<table>
									<thead>
									<tr>
										{
											// tutti i campi
											Object.keys(order.payload.items.reduce(getLastElementOr, []))

												// solo campi voluti
												.filter((articleField: string, articleFieldIndex: number) => !!Object.keys(articleFieldMap).includes(articleField))

												// nome campi
												.map((articleField: string, articleFieldIndex: number): string => articleFieldMap[articleField])

												// campi in HTML
												.map((articleField: string, articleFieldIndex: number) => (
													<th
														onClick={(clickEvent: any) => {
															// TODO ordinamento
														}}
													>
														{articleField}
													</th>
												))

										}
									</tr>
									</thead>
									<tbody>
									{
										order.payload.items
											.map((article: any, articleIndex: number) => [article, undefined])
											.flatMap((article: any, articleIndex: number) => {
												showlog('riga articolo ', article);
												return article;
											})
											.flatMap((article: any, articleIndex: number) => (
												<tr
													onClick={(clickEvent: any) => {
														// @ts-ignore
														if (!!this.state.openArticlePannels.includes(articleIndex)) {
															this.setState({
																...this.state,
																openArticlePannels: this.state.openArticlePannels.filter((op: any) => op !== articleIndex)
															});
														} else {
															showlog('inserimento in openArticlePannels', articleIndex);
															this.setState({
																...this.state,
																openArticlePannels: [...this.state.openArticlePannels, articleIndex]
															});
														}

													}}
													className={((articleIndex % 4) === 0) ? 'even-row' : 'odd-row'}
												>
													{

														!!article
															? (
																// tutti i campi
																Object.keys(article)

																	// solo campi voluti
																	.filter((articleField: string, articleFieldIndex: number) => !!Object.keys(articleFieldMap).includes(articleField))

																	// // adjust
																	// .map( (articleField: string, articleFieldIndex: number) => (article[ articleField ]))
																	// .map( (articleObj: any, articleFieldIndex: number) => {
																	// 	showlog('dentro articolo', articleObj);
																	// 	return ({
																	// 		...articleObj,
																	// 		listino: articleObj.listino.desListino +' ['+ articleObj.listino.idListino +']'
																	// 	})
																	// })


																	// campi in HTML
																	.map((articleField: string, articleFieldIndex: number) => (
																		<td>{article[articleField]}</td>
																	))
															)
															: (
																// @ts-ignore
																!!this.state.openArticlePannels.includes(articleIndex - 1)
																	? (
																		<td
																			colSpan={
																				Object.keys(order.payload.items.reduce(getLastElementOr, []))

																					// solo campi voluti
																					.filter((articleField: string, articleFieldIndex: number) => !!Object.keys(articleFieldMap).includes(articleField))

																					// nome campi
																					.map((articleField: string, articleFieldIndex: number): string => articleFieldMap[articleField])

																					.length
																			}
																		>
																			{
																				this.articleRenderer((articleIndex - 1) / 2, oIndex)
																			}
																		</td>
																	)
																	: null
															)

													}
												</tr>
											))
									}
									</tbody>
								</table>


								{/*
								<ToolkitProvider
									bootstrap4
									striped
									keyField="codice"
								>
									{
										itemsToolkitProviderProps => (
											<BootstrapTable
												/* Tabella completa * /
												bootstrap4
												striped
												{...itemsToolkitProviderProps.baseProps}
												size="sm"
												responsive
												keyField="codice"
												data={
													order.payload.items
														// non funziona al momento!
														.map( it => ({
															codice: it.codice,
															startPrice: it.startPrice,
															prezzo: it.prezzo,
															qt: it.qt,
															...it
														}))
												}
												columns={formatItemsColumns(Object.keys(order.payload.items.reduce(getLastElementOr, {name:"noName"})))}
												defaultSorted={defaultSorted}
												wrapperClasses="table-responsive articles-table"
												rowClasses={(item, rowIndex) => {
													return "";
												}}
												expandRow={{
													renderer: item => {


														let applicablePromotionsArticles = null;
														if( !!order.articlesWithApplicablePromotion ) {
															applicablePromotionsArticles =
																order.articlesWithApplicablePromotion
																	.filter( a => a.articleID == item.CodArt )
															// .reduce( getLastElementOr, null )
															;
														}


														let discountPolicy = null;
														if( !!order.discountPolicy ) {
															discountPolicy =
																order.discountPolicy

															;
														}



														// getImageData

														if(
															(
																!this.state.articlesImages ||
																(
																	!this.state.articlesImages
																		.filter( ai => ai.id === `img-${ order.companyName }-${ item.codice }` )
																		.reduce( getLastElementOr, null )
																)
															) // && !this.state.companyImagesLoaded.filter( ic => ic === order.companyName ).reduce( getLastElementOr, null )
														) {

															fetch( `https://portaleagenti.caninosrl.it/mobileagent/company/${order.companyName}/article/img/${sha256(order.agent.syncUrl + item.codice)}` )
																.then( response => response.text() )
																.then( response => {
																	showlog("response image");
																	showlog(response);
																	showlog(order);
																	showlog(item);
																	this.setState({
																			...this.state,
																			articlesImages: [
																				...this.state.articlesImages,
																				{
																					id: `img-${ order.companyName }-${ item.codice }`,
																					content: response
																				}
																			],
																			companyImagesLoaded: [
																				...this.state.companyImagesLoaded.filter( ic => ic !== order.companyName),
																				order.companyName
																			]
																		},
																		() => {
																			// showlog("stato aggiornato");
																			// showlog( this.state );
																			// showlog(
																			//     this.state.articlesImages
																			//         .filter( ai => ai.id === [`img-${ order.companyName }-${ item.codice }`] )
																			//         .reduce( getLastElementOr, null )
																			// );
																			// showlog(
																			//     !this.state.articlesImages
																			//         .filter( ai => ai.id === [`img-${ order.companyName }-${ item.codice }`] )
																			//         .reduce( getLastElementOr, null )
																			// );
																			// debugger;
																		}
																	)
																})
																.catch(e => {
																	showlog("errore al fetch");
																	showlog( e );
																	// debugger;

																	if( !this.state.companyImagesLoaded.filter( ic => ic === order.companyName ).reduce( getLastElementOr, null ) ) {

																		retrieveImages(order.agent.token, order.agent.group, order.agent.syncUrl, order.companyName)
																			.then( () => {
																				this.setState({
																					...this.state,
																					nounce: (new Date()).getTime(),
																					companyImagesLoaded: [
																						...this.state.companyImagesLoaded.filter( ic => ic !== order.companyName),
																						order.companyName
																					]
																				})
																			})
																			.catch(e => {
																				showlog("errore");
																				showlog( e );
																				// debugger;
																			})
																		;

																	}

																})
															;
														}



														return (
															<div className={"article-expanded-area"}>
																<div className={"article-info-container"}>

																	<img
																		// src={`https://portaleagenti.caninosrl.it/mobileagent/company/${order.companyName}/article/img/${sha256(order.agent.syncUrl + item.codice)}`}
																		// src={`https://portaleagenti.caninosrl.it/mobileagent/company/${order.companyName}/article/img/${sha256(order.agent.syncUrl + item.codice)}`}
																		// src={"https://portaleagenti.caninosrl.it/mobileagent/company/" + order.companyName + "/article/img/" + sha256(order.agent.syncUrl + item.codice)}
																		src={
																			(!!this.state.articlesImages
																					.filter( ai => ai.id === `img-${ order.companyName }-${ item.codice }` )
																					.reduce( getLastElementOr, null )
																			)
																				? (
																					this.state.articlesImages
																						.filter( ai => ai.id === `img-${ order.companyName }-${ item.codice }` )
																						.reduce( getLastElementOr, { content: "" } )
																						.content
																				)
																				: (
																					window.location.href
																						.split("/")
																						.filter((_, i) => i < 3)
																						.join("/")
																					+ APPS[0].logo
																				)
																		}
																		className={"real-image over-image"}
																		// onerror={'this.style.display = "none"'}
																		onError={ (e => {
																			// e.nativeEvent.target.style.display = "none";
																			// e.target.style.display = "none";

																			// showlog("image onerror");
																			// showlog(`https://portaleagenti.caninosrl.it/mobileagent/company/${ order.companyName }/article/img/${ sha256( order.agent.syncUrl + item.codice ) }`)
																			// showlog( e );

																			// debugger;
																			// retrieveImages(order.agent.token, order.agent.group, order.agent.syncUrl, order.companyName);

																			/*
																			// TODO eliminare l'immagine di sotto
																			document.getElementById(`img-${ order.companyName }-${ item.codice }`)
																				.parentNode
																				.removeChild(
																					document.getElementById(`img-${ order.companyName }-${ item.codice }`)
																				)
																			;
																			* /
																		}).bind( this )
																		}

																	/>



																	{
																		(
																			!this.state.articlesImages ||
																			(
																				!this.state.articlesImages
																					.filter( ai => ai.id === `img-${ order.companyName }-${ item.codice }` )
																					.reduce( getLastElementOr, null )
																			)
																		)
																			? (
																				<img
																					id={`img-${ order.companyName }-${ item.codice }`}
																					src={
																						window.location.href
																							.split("/")
																							.filter((_, i) => i < 3)
																							.join("/")
																						+ APPS[0].logo
																					}
																					className={`article-picture ${ (!!item.pic) ? "" : "no-article-picture" }`}
																				/>
																			)
																			: (<div style={{ minWidth: "320px", minHeight: "300px" }} />)
																	}

																	<div>
																		<h5 className={"article-name"}><strong>{ item.codice }</strong> { item.articolo }</h5>
																		<div className={"article-prices"}>
																			{
																				(item.prezzo == item.startPrice)
																					? null
																					: <div className={"article-start-price"}>{ item.startPrice } €</div>
																			}
																			<div className={"article-price"}>{ item.prezzo } €</div>
																			<div className={"article-qt"}>{ item.qt } { item.measureUnit }</div>
																		</div>

																	</div>
																	<div className={"article-details-container"}>
																		{
																			Object.keys(item.details)
																				.map( field => (
																					<div><label>{ field }</label><span>{ item[ field ] || "0" }</span></div>
																				))
																		}
																	</div>
																	<div className={"article-details-container"}>
																		<div><label>disponibilita</label><span>{ item.disponibilita || "0" }</span></div>
																		<div><label>listino</label><span>{ item.listino }</span></div>
																		<div><label>listino cliente</label><span>{ item.listinoCliente }</span></div>
																		<div><label>listino prioritario</label><span>{ item.listinoPrioritario }</span></div>
																		<div><label>listino ordinario</label><span>{ item.listinoOrdinario }</span></div>
																		<div><label>unità di misura</label><span>{ item.measureUnit }</span></div>
																		<div><label>con IVA</label><span>{ item.vatIncluded }</span></div>
																	</div>
																</div>
																<div className={"article-des-estesa"}>{ item.DesEstesa }</div>




																<Nav tabs>

																	<NavItem key={0}>
																		<NavLink
																			id={`tab-politiche-sconti`}
																			href="#"
																			className={`${ this.state.activeTab === "tab-politiche-sconti" ? "active-tab" : ""}`}
																			onClick={ () => {
																				this.setState({
																					...this.state,
																					activeTab: "tab-politiche-sconti"
																				});
																			}}>
																			<i className={'d-lg-none d-block mr-1'} />
																			<span className={`d-none d-lg-block`}>Politiche Sconto</span>
																		</NavLink>
																	</NavItem>

																	<NavItem key={1}>
																		<NavLink
																			id={`tab-promozioni`}
																			href="#"
																			className={`${ this.state.activeTab === "tab-promozioni" ? "active-tab" : ""}`}
																			onClick={ () => {
																				this.setState({
																					...this.state,
																					activeTab: "tab-promozioni"
																				});
																			}}>
																			<i className={'d-lg-none d-block mr-1'} />
																			<span className={`d-none d-lg-block`}>Promozioni</span>
																		</NavLink>
																	</NavItem>

																	<NavItem key={2}>
																		<NavLink
																			id={`tab-custom`}
																			href="#"
																			className={`${ this.state.activeTab === "tab-custom" ? "active-tab" : ""}`}
																			onClick={ () => {
																				this.setState({
																					...this.state,
																					activeTab: "tab-customi"
																				});
																			}}>
																			<i className={'d-lg-none d-block mr-1'} />
																			<span className={`d-none d-lg-block`}>Inserimento manuale</span>
																		</NavLink>
																	</NavItem>

																</Nav>

																<TabContent activeTab={ this.state.activeTab } className={"article-info-details-tables"}>

																	<TabPane
																		tabId={ "tab-politiche-sconti" }
																		key={ 0 }
																		className={""}
																	>
																		{
																			!!discountPolicy
																				? (
																					<React.Fragment>
																						<code>Politiche Sconti ( <em>TODO</em> )</code>
																						<ToolkitProvider
																							bootstrap4
																							keyField="pid"
																						>
																							{
																								toolkitProviderProps => (

																									<BootstrapTable
																										/* Tabella completa * /
																										bootstrap4
																										striped
																										{...toolkitProviderProps.baseProps}
																										size="sm"
																										responsive
																										keyField="pid"
																										data={ discountPolicy }
																										columns={formatLogsColumns(Object.keys(discountPolicy.reduce(getLastElementOr, null)))}
																										defaultSorted={defaultSorted}
																										wrapperClasses="table-responsive super-admin-dashboard-main-table"
																										rowClasses={(item, rowIndex) => {
																											return "";
																										}}
																									/>
																								)
																							}
																						</ToolkitProvider>
																					</React.Fragment>
																				)
																				: null
																		}
																	</TabPane>

																	<TabPane
																		tabId={ "tab-promozioni" }
																		key={ 1 }
																		className={""}
																	>
																		{
																			(!!applicablePromotionsArticles && !!isNotEmptyArray( applicablePromotionsArticles ))
																				? (
																					<React.Fragment>
																						<code>Promozioni</code>
																						<ToolkitProvider
																							bootstrap4
																							keyField="prid"
																						>
																							{
																								toolkitProviderProps => (

																									<BootstrapTable
																										/* Tabella completa * /
																										bootstrap4
																										striped
																										{...toolkitProviderProps.baseProps}
																										size="sm"
																										responsive
																										keyField="prid"
																										data={ applicablePromotionsArticles }
																										columns={formatLogsColumns(Object.keys(applicablePromotionsArticles.reduce( getLastElementOr, {})))}
																										defaultSorted={defaultSorted}
																										wrapperClasses="table-responsive super-admin-dashboard-main-table"
																										rowClasses={(item, rowIndex) => {
																											return "applicable-promotion-row";
																										}}
																									/>
																								)
																							}
																						</ToolkitProvider>
																					</React.Fragment>
																				)
																				: null

																		}
																	</TabPane>

																	<TabPane
																		tabId={ "tab-custom" }
																		key={ 2 }
																		className={""}
																	>
																		<code>Inserimenti manuali TODO</code>
																	</TabPane>

																</TabContent>


															</div>
														);
													},
													showExpandColumn: false,
													onlyOneExpanding: false,
													onExpand: (article, isExpand, rowIndex, e) => {
														showlog("riga espansa");
														showlog(order);
														showlog(article);
														showlog(rowIndex);
														showlog(isExpand);
														showlog(e);

														if(!!isExpand) {


														}

														return null;
													},
													className: (isExpanded, article, rowIndex) => {
														if (!!isExpanded) return '';
														return '';
													},
													parentClassName: (isExpanded, article, rowIndex) => {
														if (!!isExpanded) return 'open-article-row';
														return '';
													}
												}}
											/>
										)
									}
								</ToolkitProvider>
								*/}
							</React.Fragment>
						)
						: null
				}


				<pre className={"log-content"}>
				{
					// beautify( order )
				}
					</pre>
			</div>
		);

	}


	render() {


		showlog("render ORDER-PAGE", this.state, this.props);

		return (
			<React.Fragment>

				<div className={"logs-page-header"}>

				</div>


				<div className={"logs-page-comanders"}>

					<input
						type={"text"}
						id={"searchText"}
						placeholder={"cerca"}
					/>

					<label>Range Temporale</label>
					<div
						className={''}
						onClick={(clickEvent: any) => {
						}}
					>
						<DatePicker
							selected={new Date(this.state.search.from)}
							onChange={(newDateSelected: Date) => {
								showlog('date selected', newDateSelected, (new Date(newDateSelected)).getTime());

								// let clonedRange = JSON.parse(JSON.stringify(range));
								// clonedRange[0] = (new Date(newDateSelected)).getTime();

								showlog('range in search', this.state.search);


								// controllo range
								if ((new Date(newDateSelected)).getTime() < this.state.search.to) {
									showlog('range OK');

									this.setState({
											...this.state,
											search: {
												...this.state.search,
												from: (new Date(newDateSelected)).getTime()
											}
										},
										() => {
											this.setSearch();
										}
									);
								} else {

									// showlog('range non valido');
									// debugger;

									this.setState({
										...this.state,
										errorPannel: (
											<div className={'validity-date-alert-panel'}>
												<h4 className={''}>Attenzione</h4>
												<span>Hai selezionato una data di inizio validita precedente a quella di inizio</span>
											</div>
										)
									})


								}

							}}
							dateFormat={DATE_FORMAT_IT.toLowerCase()}
							className={''}
							customInput={<label>{moment(this.state.search.from).format(DATE_FORMAT_IT)}</label>}
							showYearDropdown
							dateFormatCalendar="MMMM"
							yearDropdownItemNumber={75}
							scrollableYearDropdown
							dropdownMode="select"
						/>

						<DatePicker
							selected={new Date(this.state.search.to)}
							onChange={(newDateSelected: Date) => {
								showlog('date selected', newDateSelected, (new Date(newDateSelected)).getTime());

								// let clonedRange = JSON.parse(JSON.stringify(range));
								// clonedRange[0] = (new Date(newDateSelected)).getTime();

								showlog('range in search', this.state.search);


								// controllo range
								if (this.state.search.from < (new Date(newDateSelected)).getTime()) {
									showlog('range OK');

									this.setState({
											...this.state,
											search: {
												...this.state.search,
												to: (new Date(newDateSelected)).getTime()
											}
										},
										() => {
											this.setSearch();
										}
									);
								} else {

									this.setState({
										...this.state,
										errorPannel: (
											<div className={'validity-date-alert-panel'}>
												<h4 className={''}>Attenzione</h4>
												<span>Hai selezionato una data di fine validita precedente a quella di inizio</span>
											</div>
										)
									})

								}

							}}
							dateFormat={DATE_FORMAT_IT.toLowerCase()}
							className={''}
							customInput={<label>{moment(this.state.search.to).format(DATE_FORMAT_IT)}</label>}
							showYearDropdown
							dateFormatCalendar="MMMM"
							yearDropdownItemNumber={75}
							scrollableYearDropdown
							dropdownMode="select"
						/>

					</div>

				</div>

				<div id={'mapContainer'} className="map-container"/>

				{
					!!this.state.rawOrderPopup
						? (
							<div
								className={"raw-order-popup-backpan"}
								onClick={clickEvent => {
									this.setState({
										...this.state,
										rawOrderPopup: null
									});
								}}
							>
								<div
									className={"raw-order-popup"}
									onClick={clickEvent => {
										clickEvent.preventDefault();
										clickEvent.stopPropagation();
									}}
								>
									<div
										className={"raw-order-popup-header"}
										onClick={clickEvent => {
											clickEvent.preventDefault();
											clickEvent.stopPropagation();
											navigator.clipboard.writeText(beautify(this.state.rawOrderPopup));
										}}
									>
										<img src={'/imgs/stack_no_shadow.png'} className={"img-clipboard"}/> <code>Copia</code>
									</div>
									<pre>{beautify(this.state.rawOrderPopup)}</pre>
								</div>
							</div>
						)
						: null
				}

				{

					(!!this.state.orders && !!isNotEmptyArray(this.state.orders))
						? (

							<React.Fragment>

								{
									!!this.state.inWaiting
										? (
											<div className={"black-backpan blur-backpan"}>
												<WaitingOverPageComponent
													panelClassName={"single-circle-waiting over-layer"}
													title={"Ricerca..."}
												/>
											</div>
										)
										: null
								}


								{/*
								<Paginator
									magnitude={ this.state.magnitude }
									currentPage={ this.state.currentPage }
									onPageChange={ pageData => {
										this.setState({
											currentPage: pageData.currentPage,
											// offset: pageData.offset,
											inWaiting: true,
										}, () => {
											this.setSearch();
										});

									}}
								/>
								*/}


								<div
									className={'table-container'}
								>
									<table>
										<thead>
										<tr>
											{
												// tutti i campi
												Object.keys(this.state.orders.reduce(getLastElementOr, []))

													// solo campi voluti
													.filter((orderField: string, orderFieldIndex: number) => !!Object.keys(orderFieldMap).includes(orderField))

													// nome campi
													.map((orderField: string, orderFieldIndex: number): string => orderFieldMap[orderField])

													// campi in HTML
													.map((orderField: string, orderFieldIndex: number) => (
														<th
															onClick={(clickEvent: any) => {
																// TODO ordinamento
															}}
														>
															{orderField}
														</th>
													))

											}
										</tr>
										</thead>
										<tbody>
										{
											this.state.orders
												.map((order: any, orderIndex: number) => [order, undefined])
												.flatMap((order: any, orderIndex: number) => {
													showlog('riga ordine ', order);
													return order;
												})
												.flatMap((order: any, orderIndex: number) => (
													<tr
														onClick={(clickEvent: any) => {

															if( !!order ) {
																// @ts-ignore
																if (!!this.state.openPannels.includes(orderIndex)) {
																	this.setState({
																		...this.state,
																		openPannels: this.state.openPannels.filter((op: any) => op !== orderIndex)
																	});
																} else {
																	this.setState({
																		...this.state,
																		openPannels: [...this.state.openPannels, orderIndex]
																	});
																}
															}



														}}
														className={((orderIndex % 4) === 0) ? 'even-row' : 'odd-row'}
													>
														{

															!!order
																? (
																	// tutti i campi
																	Object.keys(order)

																		// solo campi voluti
																		.filter((orderField: string, orderFieldIndex: number) => !!Object.keys(orderFieldMap).includes(orderField))

																		// campi in HTML
																		.map((orderField: string, orderFieldIndex: number) => (
																			<td>{order[orderField]}</td>
																		))
																)
																: (
																	// @ts-ignore
																	!!this.state.openPannels.includes(orderIndex - 1)
																		? (
																			<td
																				colSpan={
																					Object.keys(this.state.orders.reduce(getLastElementOr, []))

																						// solo campi voluti
																						.filter((orderField: string, orderFieldIndex: number) => !!Object.keys(orderFieldMap).includes(orderField))

																						// nome campi
																						.map((orderField: string, orderFieldIndex: number): string => orderFieldMap[orderField])

																						.length
																				}
																			>
																				{this.renderer((orderIndex - 1) / 2)}
																			</td>
																		)
																		: null
																)

														}
													</tr>
												))
										}
										</tbody>
									</table>
								</div>

							</React.Fragment>

						)
						: null


				}

				{
					!!this.state.errorPannel
						? (
							<AlertPanel
								content={this.state.errorPannel}
								onClose={() => {
									this.setState({
										...this.state,
										errorPannel: undefined
									})
								}}
							/>
						)
						: null
				}


			</React.Fragment>
		);

	}

	componentDidMount() {

		showlog("order componentDidMount");

		try {
			// if (!MAP) {
			MAP = new mapboxgl.Map({
				// container: mapContainer.current || document.getElementById('mapContainer'),
				container: document.getElementById('mapContainer'),
				style:
					(
						!!window.localStorage.getItem('theme')
							? (window.localStorage.getItem('theme') === 'dark')
							: (
								// selezione in automatica in base al sistema
								(!!window.matchMedia("(prefers-color-scheme: dark)") && !!window.matchMedia("(prefers-color-scheme: dark)").matches)
							)
					)
						? 'mapbox://styles/mapbox/dark-v11'
						: 'mapbox://styles/mapbox/streets-v12'
				,
				center: [this.state.lng, this.state.lat],
				zoom: this.state.zoom,
				pitch: 10,
				bearing: 0
			});

			// Add navigation control (the +/- zoom buttons)
			// @ts-ignore
			MAP.addControl(new mapboxgl.NavigationControl(), 'top-right');

			/*
			// MAP.on('load', () => {
				MAP.addSource('mapbox-dem', {
					'type': 'raster-dem',
					// 'url': 'mapbox://mapbox.terrain-rgb',
					'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
					'tileSize': 512,
					'maxzoom': 14
				});
				// add the DEM source as a terrain layer with exaggerated height
				MAP.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 2.5 });
			// });
			*/

			// }

			popup = new mapboxgl.Popup({
				offset: [0, -7],
				closeButton: false,
				closeOnClick: false
			});


			if (!!document.getElementById("searchText")) {

				// @ts-ignore
				fromEvent(document.getElementById("searchText"), 'keyup')
					.pipe(
						map((event: any) => event),
						debounceTime(750),
						distinct()
					)
					.subscribe((event) => {

						if (event.keyCode === 13) {
							if ((this.state.search.search !== event.target.value)) {
								showlog("search text subscription: " + event.target.value);

								this.setState({
										...this.state,
										search: {
											...this.state.search,
											search: event.target.value,
											page: 1
										},
										inWaiting: true,
										coords: null,
										magnitude: 0,
									},
									() => {
										this.setSearch()
									}
								)

							}
						}


					})
				;

			}

			getLastVersion()
				.then(lastVersionData => {
					this.setState({
							...this.state,
							lastVersion: !!lastVersionData ? lastVersionData.reduce(getLastElementOr, "2.90.7").version : '',
							inWaiting: true
						},
						() => {
							this.setSearch();
						}
					);

				})
				.catch(e => {
					showlog("ERROR");
					showlog(e);
				})
			;


			/*

			// channel --------------------------------------------------------------
			const socket = io("log.mobileagent.caninosrl.it", {
				// withCredentials: true
			})


			socket.on('newLiveOrder', liveOrder => {


				// showlog("%cricevuto un live order", "color: #0f0");
				// showlog( liveOrder );
				/*
				{
				  "id": "1cd88632006e3b17c783c819724013fece6b151bf800033b0c39e5651b4cfb07@1675244807317",
				  "payload": {
					"NumDocOriginale": "135768XQ00486",
					"customer": {
					  "id": 709,
					  "ragioneSociale": "PASTICCERIA BARRACO DI BARRACO VITO S.RE & C SNC *",
					  "indirizzi": [
						{
						  "provincia": "Trapani",
						  "province": "TP",
						  "cap": "91025",
						  "id": 709,
						  "sigla_provincia": "TP",
						  "regione": "Sicilia",
						  "ragione_sociale": "PASTICCERIA BARRACO DI BARRACO VITO S.RE & C SNC *",
						  "comune": "Marsala",
						  "comune_alt": "MARSALA",
						  "via": "C/DA CUORE GESU%27,340 ",
						  "name": "C/DA CUORE GESU%27,340 , 91025 Marsala",
						  "citta": "Marsala"
						}
					  ],
					  "email": "vitobarracopast@gmail.com",
					  "cellulare": "3477985611 isidoro",
					  "TipoAnagrafica": 1,
					  "address": "C/DA CUORE GESU%27,340 , 91025 Marsala",
					  "addressInternalId": 709,
					  "addressId": 0
					},
					"Cliente": "PASTICCERIA BARRACO DI BARRACO VITO S.RE & C SNC *",
					"isCloudOrder": true,
					"cloudId": "1cd88632006e3b17c783c819724013fece6b151bf800033b0c39e5651b4cfb07@1675244807317",
					"params": {}
				  },
				  "agent": {
					"id": 1357,
					"name": "ZINGALES",
					"syncUrl": "http://176.107.151.113:8080",
					"token": "WklOR0FMRVMsYWRhZGVlNDlhOWFhYWQ4OTlmODFjMGJkY2NjOGQ4MWY1ZjdiYTE5NWNjYTI4M2IzMzBlYWIyOTA0NTE4OWJkYg==",
					"group": "XQ"
				  },
				  "device": {
					"id": "68473d4d8ddcaecb",
					"os": "android",
					"screen": {
					  "width": 1142.857142857143,
					  "height": 637.7142857142857
					},
					"mac": "---",
					"phoneNumber": "",
					"brand": "samsung",
					"buildId": "SP1A.210812.016",
					"name": "Galaxy Tab A7",
					"totalDiskCapacity": 3460923392,
					"totalMemory": 2836738048,
					"freeDiskStorage": 9608224768,
					"model": "SM-T505"
				  },
				  "company": {
					"session": null,
					"DBGruppo": "XQ",
					"id": 1,
					"password": "",
					"syncURL": "http://176.107.151.113:8080",
					"name": "Liuzza",
					"operatore": "ZINGALES",
					"companyName": "LIUZZA SRL"
				  },
				  "appVersion": "2.91.8",
				  "moment": 1675244995236,
				  "closed": false
				}
				 * /

				let adr = {};
				if( !!liveOrder.payload.indirizzi && (liveOrder.payload.indirizzi.length > 0) ) {
					adr = liveOrder.payload.indirizzi[liveOrder.payload.indirizzo_default || 0];
				}
				else {
					if(!!liveOrder.payload.customer) {
						if( !!liveOrder.payload.customer.indirizzi && (liveOrder.payload.customer.indirizzi.length > 0) ) {
							adr = liveOrder.payload.customer.indirizzi[liveOrder.payload.customer.indirizzo_default || 0];
						}
						else {
							adr = liveOrder.payload.customer.address;
						}
					}
					else {
						adr = liveOrder.payload;
					}
				}
				let address = `${adr.via}%20${adr.cap}%20${adr.citta || adr.comune}%20${adr.province || adr.sigla_provincia}%20${adr.regione}`;

				geoCodeAddress( address )
					.then( coordPoint => {

						if( !coordPoint || (coordPoint.lat === 0 && coordPoint.lng === 0) ) {

							showlog("%cchiamata MapBox per geocoding", "color: #f00;");

							return(
								fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${address}.json?access_token=${process.env.REACT_APP_MAP_BOX_TOKEN}`)
									.then(response => response.json())
									.then(response => {


										// let resultOrder = result.filter(data => (!!data.payload && !!data.payload.indirizzi))[aIndex]
										let resultOrder = liveOrder;

										let preData =
											response.features
												.filter(f => (
													(f.place_type[0] === "address")
													// && (f.place_name.indexOf( coordData.order.payload.indirizzi[coordData.order.payload.indirizzo_default].via ) !== -1)
													// && (!!resultOrder.indirizzi)
													&& (f.place_name.indexOf(adr?.citta) !== -1)
												))
												[0] || null
										;

										if( !preData ) {
											preData = {
												geometry: {
													coordinates: [1,1]
												}
											}
										}

										return (
											setGeoCodeAddress(address, preData.geometry.coordinates[0], preData.geometry.coordinates[1])
												.then( storeResult => {
													// showlog("address salvato");
													// showlog( storeResult );
													return response;
												})
												.catch( e => {
													showlog("errore");
													showlog(e);
													return Promise.reject( e );
												})
										);

									})
									.then(response => ({
										order: liveOrder,  // result.filter(data => (!!liveOrder && !!liveOrder.indirizzi))[aIndex],
										coordsListData: response
									}))
									.catch(e => Promise.reject(e))
							)

						}
						else {
							return ({
								order: liveOrder, // result.filter(data => (!!liveOrder && !!liveOrder.indirizzi))[aIndex],
								coordsListData: {
									features: [{
										place_type: ["address"],
										place_name: address,
										geometry: {
											coordinates: coordPoint
										}
									}]
								}
							})
						}
					})

					// .catch( e => {
					//     // MAI
					//     showlog("ERRORE");
					//     showlog(e);
					// })


					.then((coordDataNewLiveOrder) => {
						let coords =
							[coordDataNewLiveOrder]
								.map(coordData => {
									return ({
										coordsData:
											coordData.coordsListData.features
												.filter(f => (
													(f.place_type[0] === "address")
													// && (f.place_name.indexOf( coordData.order.payload.indirizzi[coordData.order.payload.indirizzo_default].via ) !== -1)
													// && (!!coordData.order.payload.indirizzi)
													&& (f.place_name.indexOf(adr?.citta) !== -1)
												))
												// .reduce(getLastElementOr, null),
												[0] || null,
										ord: coordData.order
									})
								})

								.map(({coordsData, ord}, cIndex) => {


									// showlog("coordData");
									// showlog(coordsData);
									// debugger;

									if (!coordsData || (coordsData === null)) return null;

									return ({
										order: ord,
										lng: coordsData.geometry.coordinates[0],
										lat: coordsData.geometry.coordinates[1]
									})
								})
								.map((coord, cIndex) => {

									if (!coord || (coord === null)) return null;
									if ((coord.lng === 1) && (coord.lat === 1)) return null;

									if( !!document.getElementById(`${coord.lng},${coord.lat}`) ) {
										document.getElementById(`${coord.lng},${coord.lat}`).parentNode.removeChild( document.getElementById(`${coord.lng},${coord.lat}`) );
									}

									let el = document.createElement('div');
									el.id = `${coord.lng},${coord.lat}`;
									el.setAttribute("id", `${coord.lng},${coord.lat}`);
									// el.className = 'marker heart-beat-opacity pulse-glow';
									el.innerHTML = `
										<div class="marker-circle dissolving-wave"/>
										<div class="marker-circle pulsing-circle"/>
									`;
									if( !!coord.order.closed ) {
										el.innerHTML = `
											<svg
												height="250"
												width="250"
												viewBox={"0 0 20 20"}
											>
												<path
													fill=${ "#0af" }
													d="M5.50183983,10.4944805 L5.50367966,10.4963203 L12.8482451,3.15175489 C13.5762779,4.25592793 14,5.57848014 14,7 C14,10.866 10.866,14 7,14 C3.134,14 0,10.866 0,7 C0,3.134 3.134,0 7,0 C8.67832535,0 10.218695,0.590646458 11.4245848,1.57541523 L11.4245848,1.57541523 L5.50183983,7.49816017 L3.50183983,5.49816017 L2.00183983,6.99816017 L5.5,10.4963203 L5.50183983,10.4944805 Z"
												/>
											</svg>
										`;
									}

									let marker = new mapboxgl.Marker(el).setLngLat([coord.lng, coord.lat]).addTo(MAP);

									let totNettoMerci = coord.order.payload.items.reduce((totale, data) => {
										let qt = data.qt;
										totale += parseFloat(data.details.prezzoNettoSconti) * qt;
										return totale;
									}, 0);

									let totImponibile = parseFloat(totNettoMerci);
									totImponibile -= (totImponibile * parseFloat(coord.order.paymentPercSconto || 0) / 100);

									let qtTot = 0;
									coord.order.payload.items
										.forEach(art => {
											qtTot += parseFloat(art.qt)
										})
									;

									let totOmaggi = coord.order.payload.items.reduce((totale, data) => {
										return totale + parseFloat(data.details.omaggio);
									}, 0);
									let totScontoMerce = coord.order.payload.items.reduce((totale, data) => {
										return totale + parseFloat(data.details.scontoMerce);
									}, 0);


									totNettoMerci = parseFloat(totNettoMerci).toFixed(2);
									totImponibile = parseFloat(totImponibile).toFixed(2);

									let popup = new mapboxgl.Popup({
											offset: [0, -10],
											closeButton: false,
											closeOnClick: true
										})
											.setHTML(`
													<div class="main-tooltip-popup">
														<div class="main-tooltip-popup-row tooltip-order-customer">
															<span>${coord.order.customer}</span>
														</div>
														<div class="main-tooltip-popup-row">
															<div class="main-tooltip-popup-cell">Imponibile</div>
															<div class="main-tooltip-popup-cell important-text">${totImponibile} €</div>
														</div>
														<div class="main-tooltip-popup-row">
															<div class="main-tooltip-popup-cell">Quantità</div>
															<div class="main-tooltip-popup-cell evident-color" style="display: block;">${qtTot} di <span class="evident-color">${coord.order.itemsMagnitude}</span> articoli</div>
														</div>
														<div class="main-tooltip-popup-row">
															<div class="main-tooltip-popup-cell">Data</div>
															<div class="main-tooltip-popup-cell">${!!coord.order.payload ? moment.unix(parseInt(coord.order.payload.startOrderTime, 10) / 1000).format(DATETIME_FORMAT_IT) : "-"}</div>
														</div>
														<div class="main-tooltip-popup-row">
															<div class="main-tooltip-popup-cell">Consegna</div>
															<div class="main-tooltip-popup-cell">${coord.order.moment}</div>
														</div>
														<div class="main-tooltip-popup-row">
															<div class="main-tooltip-popup-cell">Agente</div>
															<div class="main-tooltip-popup-cell">${coord.order.operatorUsername}</div>
														</div>
														<div class="main-tooltip-popup-row">
															<div class="main-tooltip-popup-cell">Azienda</div>
															<div class="main-tooltip-popup-cell">${!!coord.order.company ? coord.order.company.name : ""}</div>
														</div>
														<div class="main-tooltip-popup-row">
															<div class="main-tooltip-popup-cell">Device</div>
															<div class="main-tooltip-popup-cell">${coord.order.device}</div>
														</div>
														<div class="main-tooltip-popup-row">
															<div class="main-tooltip-popup-cell">Versione App</div>
															<div class="main-tooltip-popup-cell dark-text">${coord.order.appVersion}</div>
														</div>
													</div>
												`)
									;
									const element = marker.getElement();

									// element.addEventListener('mouseenter', () => {
									element.addEventListener('click', () => {
										showlog("hover dell'ordine");
										showlog(coord.order);
										showlog([coord.lng, coord.lat]);
										// showlog( marker );

										popup.addTo(MAP);
									});
									element.addEventListener('mouseleave', () => popup.remove());

									marker.setPopup(popup);

									return coord;
								})

						;

						/*
						this.setState({
								...this.state,
								coords: coords,
								orders: result || [],
								inWaiting: false
							},
							() => {
								MAP.flyTo({
									center: reCenter,
									zoom: (15 - Math.floor(Math.abs(topRightCorner[0] - bottomLeftCorner[0])))
								});
								onEnd();
							}
						)
						* /


					})
					.catch(e => {
						showlog("geocodong");
						showlog(e);

						// this.setState({
						//         ...this.state,
						//         inWaiting: false
						//     },
						//     () => {
						//         onFail( e );
						//     }
						// );


					})


			})



			*/

			// ------------------------------------------------------------------------


		} catch (e) {
			showlog("ERROR");
			showlog(e);
		}


	}
}
